import { Grid } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { settings } from "app";
import permissions from "app/permissions";
import React, { useCallback, useEffect, useState } from "react";
import {
  Datagrid,
  DateField,
  FunctionField,
  ListContextProvider,
  ReferenceField,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import dataProvider from "server/dataProvider";
import SecuredComponent from "server/security/SecuredComponent";
import { graduationRequests } from "api/graduationApi";
import AssignTrainingBasesDialog from "./AssignTrainingBasesDialog";
import DeleteTrainingBaseDialog from "./DeleteTrainingBaseDialog";

const StudentTrainingBasesAdmin = ({ studentEducationId }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const [assignedTrainingBases, setAssignedTrainingBases] = useState([]);

  const fetchAssignedTrainingBases = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(graduationRequests.studentTrainingBases(studentEducationId));
      setAssignedTrainingBases(data);
    } catch (err) {
      console.error(err);
    }
  }, [studentEducationId]);

  useEffect(() => {
    if (!studentEducationId) return;
    fetchAssignedTrainingBases();
  }, [studentEducationId, fetchAssignedTrainingBases]);

  return (
    <SimpleShowLayout>
      <Grid
        container
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
          }}
        >
          <ListContextProvider value={{ data: assignedTrainingBases }}>
            <Datagrid
              rowClick={false}
              bulkActionButtons={false}
              sx={{ margin: 2, ...settings.style.secondaryDatagrid }}
            >
              <ReferenceField
                source="trainingBaseId"
                reference={graduationRequests.getStudentTrainingBasesSelect(studentEducationId)}
                label="Учебна база"
              >
                <FunctionField render={rec => `${rec.buildingName} - ${rec.wardName}`} />
              </ReferenceField>
              <TextField
                source="buildingName"
                label="Сграда"
              />
              <TextField
                source="wardName"
                label="Болнични отделения"
              />
              <DateField
                source="fromDate"
                label="От дата"
                locales="bg-BG"
              />
              <DateField
                source="toDate"
                label="До дата"
                locales="bg-BG"
              />
              <FunctionField
                render={rec => (
                  <SecuredComponent permission={permissions.canManageStudentsTrainingBases}>
                    <DeleteTrainingBaseDialog
                      fetchAssignedTrainingBases={fetchAssignedTrainingBases}
                      studentEducationId={studentEducationId}
                      trainingBaseId={rec.trainingBaseId}
                    />
                  </SecuredComponent>
                )}
              />
            </Datagrid>
          </ListContextProvider>
          <SecuredComponent permission={permissions.canManageStudentsTrainingBases}>
            <AssignTrainingBasesDialog
              assignedTrainingBases={assignedTrainingBases}
              studentEducationId={studentEducationId}
              fetchAssignedTrainingBases={fetchAssignedTrainingBases}
            />
          </SecuredComponent>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};

export default StudentTrainingBasesAdmin;
